// extracted by mini-css-extract-plugin
export var box = "_1a-2";
export var checkboxControl = "_1a-0";
export var checkboxRow = "_1a-a";
export var checked = "_1a-3";
export var descriptionSpacer = "_1a-c";
export var disabled = "_1a-4";
export var icon = "_1a-8";
export var input = "_1a-1";
export var labelSpacer = "_1a-b";
export var large = "_1a-7";
export var medium = "_1a-6";
export var small = "_1a-5";
export var text = "_1a-9";